import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/app/environments/environment';

interface ContactForm {
  name:        string;
  email:       string;
  company:     string;
  phone:       string;
  subject:     string;
  message:     string;
  inquiryType: string;
}

@Component({
  selector:    'app-contact',
  templateUrl: './contact.component.html',
  styleUrls:   ['./contact.component.css']
})
export class ContactComponent {

  private api = environment.apiUrl;

  form: ContactForm = {
    name:        '',
    email:       '',
    company:     '',
    phone:       '',
    subject:     '',
    message:     '',
    inquiryType: ''
  };

  submitting  = false;
  submitted   = false;
  errorMsg    = '';

  inquiryTypes = [
    { value: 'Sales',        label: '💼 Sales Enquiry' },
    { value: 'Support',      label: '🛠 Technical Support' },
    { value: 'Partnership',  label: '🤝 Partnership' },
    { value: 'Demo',         label: '🎥 Request a Demo' },
    { value: 'Billing',      label: '💳 Billing' },
    { value: 'Other',        label: '💬 Other' }
  ];

  get isValid(): boolean {
    return !!(
      this.form.name.trim()        &&
      this.form.email.trim()       &&
      this.form.message.trim()     &&
      this.form.inquiryType        &&
      this.isValidEmail(this.form.email)
    );
  }

  isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  get messageLength(): number {
    return this.form.message.length;
  }

  send(): void {
    if (!this.isValid || this.submitting) return;

    this.submitting = true;
    this.errorMsg   = '';

    this.http.post(`${this.api}/api/contact`, {
      name:        this.form.name.trim(),
      email:       this.form.email.trim(),
      company:     this.form.company.trim(),
      phone:       this.form.phone.trim(),
      subject:     this.form.subject.trim() ||
                   `${this.form.inquiryType} enquiry from ${this.form.name.trim()}`,
      message:     this.form.message.trim(),
      inquiryType: this.form.inquiryType
    }).subscribe({
      next: () => {
        this.submitted  = true;
        this.submitting = false;
      },
      error: (err) => {
        this.submitting = false;
        this.errorMsg   = err?.error?.message
                       ?? 'Something went wrong. Please try again or email us directly.';
      }
    });
  }

  reset(): void {
    this.submitted  = false;
    this.errorMsg   = '';
    this.form = {
      name: '', email: '', company: '',
      phone: '', subject: '', message: '', inquiryType: ''
    };
  }

  constructor(private http: HttpClient) {}
}